module.exports = __webpack_public_path__ + "static/media/certified-knowleadge.e1687ac1.svg";